module.exports = __webpack_public_path__ + "img/calendar-task.00ca768f.jpg";